<template>
  <div>
    <p class="mt-6 mb-8 text-center body-1" v-html="$t('welcome.company')" />

    <div class="w-full d-flex justify-center align-center">
      <BankIdLoginButton style="width: 100% !important;" :button-text="$t('login.password.log-in')" />
    </div>
  </div>
</template>

<script>
import BankIdLoginButton from '@/components/Common/Login/BankIdLoginButton.vue';

export default {
  name: 'Employer',

  components: {
    BankIdLoginButton
  }
}
</script>